module.exports = __webpack_public_path__ + "img/RegFees-1-sessions.3e175865.svg";